import { SVGProps } from 'react';

export const LevelsIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='13'
      height='9'
      viewBox='0 0 13 9'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <rect x='9' width='1' height='3' rx='0.5' />
      <path d='M12.5 1C12.7761 1 13 1.22386 13 1.5C13 1.77614 12.7761 2 12.5 2L11 2L11 1L12.5 1Z' />
      <path d='M8 1L8 2L0.5 2C0.223857 2 -3.39263e-08 1.77614 -2.18557e-08 1.5C-9.78513e-09 1.22386 0.223858 1 0.5 1L8 1Z' />
      <rect x='7' y='6' width='1' height='3' rx='0.5' />
      <path d='M12.5 7C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8L9 8L9 7L12.5 7Z' />
      <path d='M6 7L6 8L0.5 8C0.223857 8 -3.39263e-08 7.77614 -2.18557e-08 7.5C-9.78513e-09 7.22386 0.223858 7 0.5 7L6 7Z' />
      <rect x='3' y='3' width='1' height='3' rx='0.5' />
      <path d='M0.5 5C0.223858 5 2.66948e-09 4.77614 5.96244e-09 4.5C9.2554e-09 4.22386 0.223858 4 0.5 4L2 4L2 5L0.5 5Z' />
      <path d='M5 5L5 4L12.5 4C12.7761 4 13 4.22386 13 4.5C13 4.77614 12.7761 5 12.5 5L5 5Z' />
    </svg>
  );
};
